import '../../resources/css/settings/SettingsPage.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import SettingsMenu from '../../components/settings/SettingsMenu';
import { getTabulatorHeight } from "../common/display-setting";
import Loading from '../../components/common/Loading';
import { forwardLogin } from '../../actions/login/index';
import { checkTableAuth } from '../../components/common/access-auth';
import SettingsAccountRole from '../../components/settings/SettingsAccountRole';
import FloorPlanSettingsList from '../../components/settings/FloorPlanSettingsList';
import ModalAccountDetail from '../../components/settings/ModalAccountDetail';
import ModalAccountReadyAdd from '../../components/settings/ModalAccountReadyAdd';
import ModalRoleDetail from '../../components/settings/ModalRoleDetail';
import ModalPickRole from '../../components/picker/ModalPickRole';
import ModalPickGroup from '../../components/picker/ModalPickGroup';
import ModalPickGuestPortal from '../../components/picker/ModalPickGuestPortal';
import ModalPickNetworkZone from '../../components/picker/ModalPickNetworkZone';
import NotificationForm from '../../components/settings/NotificationForm';

import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { doGetCompleteTutorialData } from '../../actions/login/index';
import ModalLocalUpgrade from '../../components/settings/ModalLocalUpgrade';


class SettingsPage extends Component {

  constructor(props) {
    super(props);

    this.state = {
      pageSize : 10,
      tabulatorDivHeight: 0
    }
  }

  handleTutorialCallback = data => {
    const { type, index, action, status, size } = data;
    const { doGetCompleteTutorialData, authToken } = this.props;

    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      this.setState({ stepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
    }
    else if (status === STATUS.FINISHED || status === STATUS.SKIPPED) {
      this.setState({ run: false });
    }
    // else if (action === 'close') {
    //   this.setState({ run: false });
    // }

    if(((index === size - 1) && (status === STATUS.FINISHED)) || status === STATUS.SKIPPED) {
      doGetCompleteTutorialData(authToken, 8);
    }

    // console.log(status);
    // console.log(data);

  };

  setListHeight = () => {
    if (this.headerDiv) {
      let listHeight = getTabulatorHeight(this.headerDiv, 60);
      this.setState({
        tabulatorDivHeight : listHeight
      });
      // this.setState({
      //   tabulatorDivHeight : listHeight < 600 ? 600 : listHeight
      // });
    }
  }

  resizeInit = () => {
    window.onresize = () => {
      this.setListHeight();
    }
  }

  componentDidMount () {
    const { forwardLogin, accountRole, roleTableAuth, history } = this.props;
    if (checkTableAuth('settings', accountRole, roleTableAuth, 1)) {
      // has auth
      this.setListHeight();
      this.resizeInit();
    } else {
      forwardLogin("Sorry yon can't access this page.");
      history.push(window.CONFIG.WEB_ROOT + "/Login");
    }
  }

  render() {
    const { loading, subPage, accountInfoTutorial, modelOrgDetail } = this.props;
    const { pageSize, tabulatorDivHeight } = this.state;
    const tipHeight = 20;

    let pageContent = <Loading loading={loading}></Loading>;
    let modalDetailContent = <div className='modal-detail-empty'></div>;
    // if (subPage === 'auth') {
    // } else if (subPage === 'deviceProfile') {
    //   pageContent = <ProfileSettingsList pageSize={pageSize} tabulatorDivHeight={ tabulatorDivHeight }></ProfileSettingsList>;
    //   modalDetailContent = <ModalProfileDetail></ModalProfileDetail>;
    // }  else if (subPage === 'siteAndGroup') {
    //   pageContent =(
    //     <div>
    //         <SiteAndGroup pageSize={pageSize} tabulatorDivHeight={ tabulatorDivHeight - tipHeight }></SiteAndGroup>
    //     </div>
    //   );
    // } else if (subPage === 'guestPortal') {
    //   // pageContent = <GuestPortalForm></GuestPortalForm>;
    //   pageContent = <GuestPortalSettingsComponent tabulatorDivHeight={ tabulatorDivHeight - tipHeight }></GuestPortalSettingsComponent>;
    //   modalDetailContent = (
    //     <div>
    //       <ModalGuestPortalSettingsDetail></ModalGuestPortalSettingsDetail>
    //     </div>
    //   );
    // } else
    if (subPage === 'accounts') {
      pageContent = <SettingsAccountRole pageSize={pageSize} tabulatorDivHeight={ tabulatorDivHeight - tipHeight }></SettingsAccountRole>;
      modalDetailContent = (
        <div>
          <ModalAccountDetail></ModalAccountDetail>
          <ModalAccountReadyAdd></ModalAccountReadyAdd>
          <ModalRoleDetail></ModalRoleDetail>
        </div>
      );
    } else if (subPage === 'notification') {
      pageContent = <NotificationForm></NotificationForm>;
    } else if (subPage === 'floorplan') {
      pageContent = <FloorPlanSettingsList pageSize={pageSize} tabulatorDivHeight={ tabulatorDivHeight - tipHeight }></FloorPlanSettingsList>;
    // } else if (subPage === 'network') {
    //   pageContent = <NetworkForm></NetworkForm>;
    // } else if (subPage === 'advance') {
    //   pageContent = <AdvanceForm></AdvanceForm>;
    // } else if (subPage === 'about') {
    //   pageContent = <AboutForm></AboutForm>;
    //   modalDetailContent = (
    //     <div>
    //       <ModalExportDbDetail></ModalExportDbDetail>
    //       <ModalSysDate></ModalSysDate>
    //     </div>
    //   );
    // } else if (subPage === 'wifi') {
    //   pageContent = <WiFiSettingsComponent></WiFiSettingsComponent>;
    //   modalDetailContent = (
    //     <div>
    //       <ModalWiFiSettingsDetail></ModalWiFiSettingsDetail>
    //       <ModalNetworkZoneDetail></ModalNetworkZoneDetail>
    //       <ModalGroupAPSettingsDetail></ModalGroupAPSettingsDetail>
    //       <ModalApExclusionsSettingsDetail></ModalApExclusionsSettingsDetail>
    //     </div>
    //   );
    }

    let monitor = (
      <div className='area-settings-monitor'>

        { modelOrgDetail && accountInfoTutorial ?
        <Joyride
            callback={this.handleTutorialCallback}
            // autoStart
            run={true}
            steps={[
              {
                title: "Settings Menu",
                target: ".area-menu-item-option",
                content: <span>Navigate different setting details by clicking menu item here:<br /><br />
                               {/* (1) Auth Settings: Choose LDAP or RADIUS for login authentication<br /><br /> */}
                               (1) Site and Group Settings:<br /><br />
                               - Site Settings: Edit site detail in site settings form<br />
                               - Group Settings: Add new group, view group info, edit group detail or delete group in group settings<br /><br />
                               (2) Guest Portal Settings: Customize and preview your own guest portal page<br /><br />
                               (3) Accounts:<br /><br />
                               - Account Settings: Add new account, view, edit, or delete account detail<br />
                               - Role Settings: Add new role, view, edit, or delete role detail<br /><br />
                               (4) Notification Settings: Set up SMTP server for alert notifications<br /><br />
                               (5) Network Settings: Set up network settings by choosing connection type<br /><br />
                               (6) Wi-Fi Clusters: <br /><br />
                               - Network Zone: Add network zone, view info, edit or delete network zone<br />
                               - Wi-Fi SSID: Add new Wi-Fi, view Wi-Fi info, edit or delete Wi-Fi settings<br />
                               - Site AP Settings: Adjust channel width and transmit power for different radio<br /><br />
                               (7) Advance: Sync device SSH and web GUI authentication<br /><br />
                               (8) About: View system information, export data, or check latest update 
                         </span>,
                disableBeacon: true,
                locale: {
                  skip: "Skip",
                  // next: "Next",
                  last: "Close",
                },
                disableOverlayClose: true,
                placement: "right-start",
                styles: {
                  tooltipContainer: {
                    textAlign: 'left'
                  }
                },
                // stepIndex: 0,
              },
            ]}
            // stepIndex={stepIndex}
            styles={{
              options: {
                primaryColor: '#0084dd',
                arrowColor: 'white',
                textColor: 'white',
                overlayColor: 'rgba(0, 0, 0, .8)',
                zIndex: 1000,
              },
              spotlight: {
                position: 'fixed',
                borderColor: 'white',
                borderRadius: '10px',
                outline: 'dashed white 2px',
                outlineOffset: '8px',
                // borderStyle: 'dashed',
                // backgroundColor: 'none',
                // borderWidth: 'medium'
              },
              tooltipTitle: {
                color: 'white'
              },
              tooltip: {
                borderRadius: '10px',
                backgroundColor: 'none',
                border: 'solid',
                borderColor: 'white',
                wordBreak: 'break-all',
                width: '650px',
                pointerEvents: 'initial',
                // position: 'absolute',
                // top: '200px',
                // left: '400px',
              },
              tooltipInner: {
                // whiteSpace: 'pre-line',
                maxWidth: '100%',
              },
              buttonBack: {
                color: 'white',
              },
              buttonNext: {
                color: '#595959',
                backgroundColor: 'none',
              },
              buttonClose: {
                display: 'none',
              },
            }}
            // showProgress
            showSkipButton
            continuous={true}
        /> : ''
        }
        <div className='area-setting-page-header' ref={ (headerDiv) => { this.headerDiv = headerDiv } }>
          <span className='area-setting-page-header-item'>Settings</span>
        </div>
        <div className='area-setting-page-body'>
          <div className='area-navigation-header'>
            <SettingsMenu></SettingsMenu>
          </div>
          <div className='area-body'>
            <div className='area-page-content'>
              { pageContent }
            </div>
          </div>
        </div>
        <div className='area-modal-datail'>
          { modalDetailContent }
        </div>
        <ModalPickRole></ModalPickRole>
        <ModalPickGroup></ModalPickGroup>
        <ModalLocalUpgrade></ModalLocalUpgrade>
        <ModalPickGuestPortal></ModalPickGuestPortal>
        <ModalPickNetworkZone></ModalPickNetworkZone>
    </div>
    );

    return (
      <div className='area-settings-page area-page'>
        {monitor}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { subPage } = ownProps.match.params;
  const completeTutorial = !state.loginReducers?.accountInfo?.completeTutorial?.split(',').find(e => e === '8');

  return {
    authToken: state.loginReducers.authToken,
    accountRole: state.loginReducers.accountRole,
    roleTableAuth: state.loginReducers.roleTableAuth,
    subPage: subPage,
    accountInfoTutorial: completeTutorial,
    modelOrgDetail: state.modelReducers.modelOrgDetail
  }
}

export default withRouter(connect(
  mapStateToProps,
  { forwardLogin, doGetCompleteTutorialData }
)(SettingsPage))
